const FRONT_DESK_DETAIL_ACTION_TYPES = {
  FRONT_DESK_DETAIL: 'FRONT_DESK_DETAIL',
};

export default FRONT_DESK_DETAIL_ACTION_TYPES;
